import { render } from "./PourquoiBio.vue?vue&type=template&id=01d385a1"
import script from "./PourquoiBio.vue?vue&type=script&lang=js"
export * from "./PourquoiBio.vue?vue&type=script&lang=js"

import "./PourquoiBio.vue?vue&type=style&index=0&id=01d385a1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__